module.exports = __webpack_public_path__ + "static/Inter-Bold-e7ae98681edfa1df7f1e3ebba0d4fb88.woff2";